import { render } from "./ChatSearch.vue?vue&type=template&id=09857657&scoped=true&ts=true"
import script from "./ChatSearch.vue?vue&type=script&lang=ts"
export * from "./ChatSearch.vue?vue&type=script&lang=ts"

import "./ChatSearch.vue?vue&type=style&index=0&id=09857657&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09857657"]])

export default __exports__